import { Button } from '@/components/ui/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import React from 'react';
import { connect } from 'react-redux';
import {
  showMatchInbox,
  showMatchInboxSelection,
  toggleAllMatchesAction
} from '../../../app/redux/actions/userMatchActions';
import { AppDispatch, RootState } from '../../../app/redux/configureStore';
import { useAppSelector } from '../../../app/redux/hooks';
import { UserMatch } from '../../../app/redux/reducers/userMatchesReducer';
import { MessageOrgLogo } from './MatchBody';
import { useUserMatches } from './hooks/UseUserMatches';

interface MatchHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  match?: UserMatch;
  showMatchInbox: AppDispatch;
  toggleAllMatches: AppDispatch;
  showInboxSelection: AppDispatch;
}

const MatchHeader = ({ match, showMatchInbox, showInboxSelection, toggleAllMatches }: MatchHeaderProps) => {
  const { showInbox, showMatchSelection } = useAppSelector((state: RootState) => state.matches);
  const { resetInbox, numMatches } = useUserMatches();
  const hasMatches = numMatches > 0;
  const showHeaderWithLogo = !showInbox && hasMatches;
  const handleOnSelect = () => {
    if (showMatchSelection) {
      toggleAllMatches(false);
      showInboxSelection(false);
    } else showInboxSelection(true);
  };

  return (
    <>
      <div
        className={`w-full flex items-center text-gray-800 border-gray-200 px-5 h-[52px] ${
          !showHeaderWithLogo ? 'justify-around' : 'justify-between'
        }`}
      >
        {!showHeaderWithLogo ? (
          <>
            <div className={`absolute left-4 ${hasMatches ? '' : 'opacity-0'}`}>
              <Button size="sm" variant="bare" data-cy={`button:select messages`} onClick={handleOnSelect}>
                {showMatchSelection ? 'Cancel' : 'Select'}
              </Button>
            </div>
            <div>
              <h1 className="font-semibold text-sm">Messages</h1>
            </div>
          </>
        ) : (
          <>
            <button
              className={``}
              aria-label={'Back to inbox'}
              onClick={() => {
                resetInbox();
                showMatchInbox(true);
              }}
            >
              <FontAwesomeIcon icon={['far', 'arrow-left']} className={`w-4 h-4`} />
            </button>
            <div className="flex items-center space-x-2 mx-auto">
              <div className="justify-center mb-1 p-1 rounded-md shadow-sm w-11 h-11">
                {match?.content?.path ? (
                  <Link to={match.content?.path} data-cy={`image:view-organisation`}>
                    <MessageOrgLogo org={match?.content} />
                  </Link>
                ) : (
                  <MessageOrgLogo org={match?.content} />
                )}
              </div>
              {match?.content?.title && (
                <div className="font-semibold text-base max-w-[15rem] leading-6 line-clamp-2 text-gray">
                  {match?.content?.title}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <div className={`border-b border-gray-200`} />
    </>
  );
};

const mapActionsToProps = {
  toggleAllMatches: toggleAllMatchesAction,
  showInboxSelection: showMatchInboxSelection,
  showMatchInbox: showMatchInbox
};
export default connect(null, mapActionsToProps)(MatchHeader);
